// @ts-nocheck
import { IAction } from 'shared/store-checkout/types/redux'
import { CartControllerResponseV2 } from 'types/api/cart'
import { DeleteOffer } from 'types/redux'

import {
  ADD_ERROR_NOTIFICATION_ACTION,
  ADD_VOUCHER_ERROR,
  ADD_VOUCHER_REQUEST,
  ADD_VOUCHER_SUCCESS,
  CART_ERROR,
  CART_SHIPPING_BOX_UNMOUNTED,
  CHANGE_COLLECTIVE_ORDER_SUCCESS,
  CHANGE_PRESCRIPTION_FOLLOWS_SUCCESS,
  DELETE_CART_ERX_ITEM_REQUEST,
  DELETE_CART_ITEM_REQUEST,
  DELETE_CART_ITEM_SUCCESS,
  DELETE_CART_ITEMS,
  DELETE_REDPOINTS_SUCCESS,
  DELETE_VOUCHER_REQUEST,
  DELETE_VOUCHER_SUCCESS,
  OPTIMISTIC_UPDATE_COLLECTIVE_ORDER,
  OPTIMISTIC_UPDATE_PRESCRIPTION_FOLLOWS,
  RESET_VOUCHER_ERROR,
  RESET_VOUCHER_SUCCESS,
  SET_COLLECTIVE_ORDER,
  UPDATE_CART_SUCCESS,
  UPDATE_CART_VOUCHER_ERROR,
  UPDATE_REDPOINTS_ERROR,
  UPDATE_REDPOINTS_REQUEST,
  UPDATE_REDPOINTS_SUCCESS,
} from './types.consts'

type UpdateCartSuccessAction = IAction<
  CartControllerResponseV2,
  typeof UPDATE_CART_SUCCESS
>
type UpdateCartVoucherErrorAction = IAction<
  {
    voucherError?: string
    promotionErrorMessage?: string
  },
  typeof UPDATE_CART_VOUCHER_ERROR
>

type UpdateCollectionOrderSuccessAction = IAction<
  boolean,
  typeof SET_COLLECTIVE_ORDER
>
type AddVoucherRequestAction = { type: typeof ADD_VOUCHER_REQUEST }
type AddVoucherErrorAction = { type: typeof ADD_VOUCHER_ERROR }
type AddVoucherSuccessAction = { type: typeof ADD_VOUCHER_SUCCESS }
type ResetVoucherAction = { type: typeof RESET_VOUCHER_SUCCESS }
type ResetVoucherErrorAction = { type: typeof RESET_VOUCHER_ERROR }
type DeleteVoucherRequestAction = { type: typeof DELETE_VOUCHER_REQUEST }
type DeleteVoucherSuccessAction = { type: typeof DELETE_VOUCHER_SUCCESS }
type DeleteCartItemSuccessAction = {
  type: typeof DELETE_CART_ITEM_SUCCESS
}
type DeleteCartItemRequestAction = { type: typeof DELETE_CART_ITEM_REQUEST }
type DeleteCartERxItemRequestAction = {
  type: typeof DELETE_CART_ERX_ITEM_REQUEST
}
type AddErrorAction = IAction<string, typeof CART_ERROR>
type AddErrorNotificationAction = IAction<
  string,
  typeof ADD_ERROR_NOTIFICATION_ACTION
>
type UpdateRedPointsErrorAction = { type: typeof UPDATE_REDPOINTS_ERROR }
type UpdateRedPointsRequestAction = { type: typeof UPDATE_REDPOINTS_REQUEST }
type UpdateRedPointsSuccessAction = { type: typeof UPDATE_REDPOINTS_SUCCESS }
type DeleteRedPointsSuccessAction = { type: typeof DELETE_REDPOINTS_SUCCESS }
type ChangePrescriptionFollowsSuccessAction = {
  type: typeof CHANGE_PRESCRIPTION_FOLLOWS_SUCCESS
}
type ChangeCollectiveOrderSuccessAction = {
  type: typeof CHANGE_COLLECTIVE_ORDER_SUCCESS
}
type CartShippingBoxUnmountedAction = {
  type: typeof CART_SHIPPING_BOX_UNMOUNTED
}

export const updateCartSuccessAction = (
  payload: CartControllerResponseV2
): UpdateCartSuccessAction => {
  return {
    type: UPDATE_CART_SUCCESS,
    payload,
  }
}

export const updateCartVoucherErrorAction = (
  voucherError: string,
  promotionErrorMessage?: string
): UpdateCartVoucherErrorAction => {
  return {
    type: UPDATE_CART_VOUCHER_ERROR,
    payload: {
      voucherError,
      promotionErrorMessage,
    },
  }
}

export const updateCollectionOrderSuccessAction = (
  payload: boolean
): UpdateCollectionOrderSuccessAction => {
  return {
    type: SET_COLLECTIVE_ORDER,
    payload,
  }
}

export const updateCartShippingBoxMountedAction = (
  payload: boolean
): CartShippingBoxUnmountedAction => {
  return { type: CART_SHIPPING_BOX_UNMOUNTED, payload }
}

export const deleteCartItemSuccessAction = (): DeleteCartItemSuccessAction => ({
  type: DELETE_CART_ITEM_SUCCESS,
})

export const deleteCartERxItemSuccessAction =
  (): DeleteCartItemSuccessAction => ({
    type: DELETE_CART_ITEM_SUCCESS,
  })

export const deleteCartItemRequestAction = (): DeleteCartItemRequestAction => ({
  type: DELETE_CART_ITEM_REQUEST,
})

export const deleteCartERxItemRequestAction =
  (): DeleteCartERxItemRequestAction => ({
    type: DELETE_CART_ERX_ITEM_REQUEST,
  })

export const addVoucherRequestAction = (): AddVoucherRequestAction => ({
  type: ADD_VOUCHER_REQUEST,
})

export const addVoucherSuccessAction = (): AddVoucherSuccessAction => ({
  type: ADD_VOUCHER_SUCCESS,
})

export const addVoucherErrorAction = (): AddVoucherErrorAction => ({
  type: ADD_VOUCHER_ERROR,
})

export const resetVoucherAction = (): ResetVoucherAction => ({
  type: RESET_VOUCHER_SUCCESS,
})

export const resetVoucherErrorAction = (): ResetVoucherErrorAction => ({
  type: RESET_VOUCHER_ERROR,
})

export const deleteVoucherRequestAction = (): DeleteVoucherRequestAction => ({
  type: DELETE_VOUCHER_REQUEST,
})

export const deleteVoucherSuccessAction = (): DeleteVoucherSuccessAction => ({
  type: DELETE_VOUCHER_SUCCESS,
})

export const updateRedPointsRequestAction =
  (): UpdateRedPointsRequestAction => ({
    type: UPDATE_REDPOINTS_REQUEST,
  })

export const changePrescriptionFollowsSuccessAction =
  (): ChangePrescriptionFollowsSuccessAction => ({
    type: CHANGE_PRESCRIPTION_FOLLOWS_SUCCESS,
  })

export const changeCollectiveOrderSuccessAction =
  (): ChangeCollectiveOrderSuccessAction => ({
    type: CHANGE_COLLECTIVE_ORDER_SUCCESS,
  })

export const updateRedPointsErrorAction = (): UpdateRedPointsErrorAction => ({
  type: UPDATE_REDPOINTS_ERROR,
})

export const updateRedPointsSuccessAction =
  (): UpdateRedPointsSuccessAction => ({
    type: UPDATE_REDPOINTS_SUCCESS,
  })

export const deleteRedPointsSuccessAction =
  (): DeleteRedPointsSuccessAction => ({
    type: DELETE_REDPOINTS_SUCCESS,
  })

export const addErrorAction = (payload: string): AddErrorAction => ({
  type: CART_ERROR,
  payload,
})

export const addErrorNotificationAction = (
  payload: string
): AddErrorNotificationAction => ({
  type: ADD_ERROR_NOTIFICATION_ACTION,
  payload,
})

type UpdatePrescriptionFollowsAction = IAction<
  boolean,
  typeof OPTIMISTIC_UPDATE_PRESCRIPTION_FOLLOWS
>
export const updatePrescriptionFollowsAction = (
  payload: boolean
): UpdatePrescriptionFollowsAction => ({
  type: OPTIMISTIC_UPDATE_PRESCRIPTION_FOLLOWS,
  payload,
})

type UpdateCollectiveOrderAction = IAction<
  boolean,
  typeof OPTIMISTIC_UPDATE_COLLECTIVE_ORDER
>
export const updateCollectiveOrderAction = (
  payload: boolean
): UpdateCollectiveOrderAction => ({
  type: OPTIMISTIC_UPDATE_COLLECTIVE_ORDER,
  payload,
})

type DeleteCartOffersAction = IAction<DeleteOffer[], typeof DELETE_CART_ITEMS>
export const deleteCartOffersAction = (
  offers: DeleteOffer[]
): DeleteCartOffersAction => ({
  type: DELETE_CART_ITEMS,
  offers,
})

export type CartActionTypes =
  | AddErrorAction
  | AddErrorNotificationAction
  | AddVoucherRequestAction
  | AddVoucherErrorAction
  | AddVoucherSuccessAction
  | DeleteCartItemRequestAction
  | DeleteCartERxItemRequestAction
  | DeleteCartItemSuccessAction
  | DeleteRedPointsSuccessAction
  | DeleteVoucherSuccessAction
  | DeleteCartOffersAction
  | ResetVoucherAction
  | ResetVoucherErrorAction
  | DeleteVoucherRequestAction
  | UpdateCartSuccessAction
  | UpdateCollectionOrderSuccessAction
  | ChangePrescriptionFollowsSuccessAction
  | UpdateRedPointsErrorAction
  | UpdateRedPointsRequestAction
  | UpdateRedPointsSuccessAction
  | UpdatePrescriptionFollowsAction
  | UpdateCollectiveOrderAction
